import React from "react";
import { Layout } from "antd";
import './sidebar.css'
import SideMenu from "./sideMenu/SideMenu";

interface SideBarProps {
  changeActiveTab: (tabName: string) => (event: React.MouseEvent) => void
}

const SideBar: React.FC<SideBarProps> = ({changeActiveTab}) => {
  return (
  
    <Layout.Sider
      className="sidebar" 
      breakpoint={"lg"}
      collapsedWidth={0}
      trigger={null}
      width={220}>
        <SideMenu changeActiveTab={changeActiveTab}/>
    </Layout.Sider>
   );
};
export default SideBar;